export const apiUrls = {
  /** Pools */
  poolsRegistered: '/pools/registered',

  /** Coins */
  coinsRegistered: '/coins/registered',
}
